export default __webpack_public_path__ + "static/media/2_0144.a1021e67.webp";